export const AVAILABLE_AFTER_COMPLETION = 'available after competition';

export const CREATOR = 'donalireland';

export const UPLOAD_IMAGE = '/images/wireframe/white-image.png';


export const EVENT_UPLOAD_ENDPOINT = '/event/upload';

export const uploadTypes = {
    RESULTS_UPLOAD: 'RESULTS_UPLOAD',
    HANDS_UPLOAD: 'HANDS_UPLOAD',
    IMAGE_UPLOAD: 'IMAGE_UPLOAD',
    WINNERS_UPLOAD: 'WINNERS_UPLOAD'
}

export const EVENT_SHOW_LINK = '/event/show'

export const RESULTS_DETAILS_LINK = '/resultDetails';

export const RESULTS_HANDS_LINK = '/resultHands';

export const BRIDGEMATE_BLACK_LOGO_PATH = '/images/wireframe/black-logo.png'

export const GA_TRACKING_RESULTS_UPLOAD = '/eventResultsUpload';

export const GA_TRACKING_LANDING_PAGE = '/landingPage';

export const GA_TRACKING_CREATE_PAGE = '/createPage';

export const GA_TRACKING_EDIT_PAGE = '/editPage';

export const GA_TRACKING_EVENT_DETAILS_PAGE = '/eventDetailsPage';

export const GA_TRACKING_UPLOAD_IMAGE_PAGE = '/uploadImagePage';

export const GA_TRACKING_UPLOAD_WINNERS_PAGE = 'uploadWinnersPage'

export const GA_TRACKING_UPLOAD_RESULTS_PAGE = '/uploadResultsPage';

export const GA_TRACKING_UPLOAD_HANDS_PAGE = "/uploadHandsPage";

export const GA_TRACKING_RESULTS_PAGE = '/resultsPage';

export const GA_TRACKING_RESULTS_DETAILS_PAGE = '/resultsDetailsPage';
